import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import type { RecordAbonements } from "@/lib/appointment/abonements";

/**
 * Which lines of an appointment a client package pays, and which packages could
 * pay each line (boona: GET /company/abonements/for-record/{id}).
 * `serviceIds` = the lines on the modal now (they may not be saved yet).
 */
export function useRecordAbonements(recordId: number | string | undefined, serviceIds: number[]) {
  const ids = [...new Set(serviceIds.filter((x) => Number.isFinite(x) && x > 0))].sort((a, b) => a - b);
  return useQuery<RecordAbonements>({
    queryKey: ["recordAbonements", Number(recordId), ids.join(",")],
    queryFn: async () => {
      const { data } = await apiClient.get(`/api/v1/company/abonements/for-record/${recordId}`, {
        params: { service_ids: ids.join(",") },
      });
      return { uses: data?.uses ?? [], options: data?.options ?? {} };
    },
    enabled: !!recordId && ids.length > 0,
    staleTime: 30 * 1000,
  });
}
